import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Country from "@/pcm/store/models/Country";
import SubscriptionClientSocial from "@/pcm/store/models/SubscriptionClientSocial";
import SubscriptionClientYoutubeAccount from "@/pcm/store/models/SubscriptionClientYoutubeAccount";
import SubscriptionClientActivity from "@/pcm/store/models/SubscriptionClientActivity";

export default class SubscriptionClient extends Model {
    static entity = 'subscription_clients';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            country_id: this.attr(null),
            first_name: this.string(''),
            last_name: this.string(''),
            email: this.string(''),
            email_verified_at: this.string(null).nullable(),
            address: this.string(''),
            zip_code: this.string(''),
            city: this.string(''),
            company_name: this.string(null).nullable(),
            state: this.string(null).nullable(),
            vat_number: this.string(null).nullable(),
            chamber_of_commerce: this.string(null).nullable(),
            social_status: this.string(null).nullable(),
            youtube_status: this.string(null).nullable(),
            max_downloads_per_day: this.number(null).nullable(),

            created_at: this.string(''),
            updated_at: this.string(''),

            // Relations
            country: this.belongsTo(Country, 'country_id'),
            socials: this.hasMany(SubscriptionClientSocial, 'subscription_client_id'),
            youtubeAccounts: this.hasMany(SubscriptionClientYoutubeAccount, 'subscription_client_id'),
            activities: this.hasMany(SubscriptionClientActivity, 'subscription_client_id'),
            defaultSubscription: this.attr(null),
            youtubeSubscription: this.attr(null),
            stripe: this.attr(null),
        }
    }

    declare id: number;
    declare country_id: number;
    declare first_name: string;
    declare last_name: string;
    declare email: string;
    declare email_verified_at: string | null;
    declare address: string;
    declare zip_code: string;
    declare city: string;
    declare company_name: string | null;
    declare state: string | null;
    declare vat_number: string | null;
    declare chamber_of_commerce: string | null;
    declare social_status: string | null;
    declare youtube_status: string | null;
    declare max_downloads_per_day: number | null;
    declare defaultSubscription: any;
    declare youtubeSubscription: any;
    declare stripe: any;

    declare country: Country | null;
    declare socials: SubscriptionClientSocial[];
    declare youtubeAccounts: SubscriptionClientYoutubeAccount[];
    declare activities: SubscriptionClientActivity[];
}
